module.exports = __webpack_public_path__ + "static/media/horse_girl.49d15db3.png";